import { LayoutService } from '@/layout/service/layout.service';
import { NavegacaoStore } from '@/layout/store/navegacao.store';
import { CommonModule } from '@angular/common';
import { Component, computed, ElementRef, inject, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SkeletonModule } from 'primeng/skeleton';
import { AppMenu } from './app.menu';

@Component({
  selector: '[app-sidebar]',
  standalone: true,
  imports: [AppMenu, RouterModule, CommonModule, SkeletonModule, IconFieldModule, InputIconModule, InputTextModule],
  template: `<div class="layout-sidebar" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <div class="sidebar-header">
      <a [routerLink]="['/']" class="app-logo">
        <img [src]="caminhoLogoSidebar()" width="168" height="56" alt="GestHOSP - PEP" />
      </a>

      <button class="z-20 layout-sidebar-anchor p-link" type="button" (click)="anchor()"></button>
    </div>

    <div class="px-2 py-2 shrink-0 border-b border-surface-200 dark:border-surface-700">
      <p-iconfield class="w-full">
        <p-inputicon class="pi pi-search" />
        <input
          type="search"
          pInputText
          placeholder="Buscar no menu"
          class="w-full"
          aria-label="Buscar itens do menu"
          autocomplete="off"
          [value]="store.termoBuscaMenu()"
          (input)="onTermoBuscaMenuAlterado($event)"
        />
      </p-iconfield>
    </div>

    <div #menuContainer class="layout-menu-container">
      <app-menu></app-menu>
    </div>
  </div>`,
})
export class AppSidebar {
  protected readonly store = inject(NavegacaoStore);

  private readonly layoutService = inject(LayoutService);

  protected readonly caminhoLogoSidebar = computed(() =>
    this.layoutService.isDarkTheme() === true ? 'assets/images/logo-dark.png' : 'assets/images/logo.png',
  );

  timeout: ReturnType<typeof setTimeout> | null = null;

  @ViewChild('menuContainer') menuContainer!: ElementRef;
  public readonly el = inject(ElementRef);

  public onMouseEnter(): void {
    if (!this.layoutService.layoutState().anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.layoutService.layoutState.update((state) => {
        if (!state.sidebarActive) {
          return { ...state, sidebarActive: true };
        }
        return state;
      });
    }
  }

  public onMouseLeave(): void {
    if (!this.layoutService.layoutState().anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(() => {
          this.layoutService.layoutState.update((state) => {
            if (state.sidebarActive) {
              return { ...state, sidebarActive: false };
            }
            return state;
          });
        }, 300);
      }
    }
  }

  public anchor(): void {
    this.layoutService.layoutState.update((state) => ({
      ...state,
      anchored: !state.anchored,
    }));
  }

  protected onTermoBuscaMenuAlterado(event: Event): void {
    const alvo = event.target;
    if (!(alvo instanceof HTMLInputElement)) {
      return;
    }
    this.store.definirTermoBuscaMenu(alvo.value);
  }
}
